export const defaultIsOptionDisabled = () => false;
export function defaultOptionLabel(option) {
    return String(option.label ?? "");
}
export function defaultOptionValue(option) {
    return option.value;
}
export const defaultCreateOptionMessage = (inputValue) => {
    return `Create "${inputValue}"`;
};
